@if (isPublicFooter()) {
  <footer class="app-footer app-footer--public" [class.app-footer--with-bottom-nav]="withBottomNav">
    <div class="app-footer-inner app-footer-inner--public">
      <div class="footer-grid">
        <div class="footer-brand-block">
          <a class="footer-brand footer-brand--public" routerLink="/landing" aria-label="PeerLiv">
            <span class="brand-icon" aria-hidden="true">
              <span class="brand-mark"></span>
            </span>
            <span class="brand-name brand-name--public">PeerLiv</span>
          </a>
          <p class="footer-brand-copy">
            Peer health community for people on health journeys. Built with care in India.
          </p>
        </div>

        <div class="footer-column">
          <h4>Company</h4>
          <nav class="footer-link-list" aria-label="Company">
            @for (link of companyLinks; track link.label) {
              <a [routerLink]="link.routerLink" [fragment]="link.fragment">{{ link.label }}</a>
            }
          </nav>
        </div>

        <div class="footer-column">
          <h4>Legal</h4>
          <nav class="footer-link-list" aria-label="Legal">
            @for (link of legalLinks; track link.label) {
              <a [routerLink]="link.routerLink" [fragment]="link.fragment">{{ link.label }}</a>
            }
          </nav>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="footer-copy footer-copy--public">
          &copy; {{ currentYear }} PeerLiv &middot; Built with care for people on health journeys
        </p>
        <p class="footer-note footer-note--public">
          <span class="footer-note-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
            </svg>
          </span>
          This is peer support, not medical prescriptions. Always consult your doctor.
        </p>
      </div>
    </div>
  </footer>
} @else {
  <footer class="app-footer" [class.app-footer--with-bottom-nav]="withBottomNav">
    <div class="app-footer-inner">
      <div class="footer-top">
        <a class="footer-brand" routerLink="/" aria-label="PeerLiv">
          <span class="brand-icon" aria-hidden="true">
            <span class="brand-mark"></span>
          </span>
          <span class="brand-name">PeerLiv</span>
        </a>

        <nav class="footer-links" aria-label="Footer links">
          <a routerLink="/about">About</a>
          <a routerLink="/privacy">Privacy</a>
          <a routerLink="/terms">Terms</a>
          <a routerLink="/community-guidelines">Community Guidelines</a>
          <a routerLink="/contact">Contact</a>
        </nav>
      </div>

      <p class="footer-copy">&copy; {{ currentYear }} PeerLiv &middot; Built with care for people on health journeys</p>
      <p class="footer-note">Peer support only. Not a replacement for medical advice.</p>
    </div>
  </footer>
}
